'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useRef } from 'react';
import ReadMoreText from '@/components/ReadMoreText';
import { cn } from '@/lib/utils';
type StaffDescriptionProps = {
  description: string;
};
function StaffDescription(t0) {
  const $ = _c(19);
  const {
    description
  } = t0;
  const t = useTranslations();
  const sectionRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      requestAnimationFrame(() => {
        sectionRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      });
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleCollapse = t1;
  let t2;
  if ($[1] !== t) {
    t2 = t("world-info.staff-description");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <h2 className="text-[16px] leading-6 font-semibold tracking-[0.2px] text-white">{t2}</h2>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== description) {
    t4 = <div className="[&_a]:text-vive-brand-40 [&_a]:hover:text-vive-brand-50 [&_blockquote]:border-vive-primary-60 [&_code]:bg-vive-ghost-white [&_li]:marker:text-vive-primary-30 [&_a]:underline [&_a]:transition-colors [&_blockquote]:my-4 [&_blockquote]:border-l-2 [&_blockquote]:pl-4 [&_code]:rounded-sm [&_code]:px-1 [&_code]:wrap-break-word [&_em]:italic [&_h1]:my-3 [&_h1]:text-[24px] [&_h1]:leading-8 [&_h1]:font-extrabold [&_h1]:tracking-[0.15px] lg:[&_h1]:my-4 lg:[&_h1]:text-[30px] lg:[&_h1]:leading-10 lg:[&_h1]:tracking-[0.12px] [&_h2]:my-2.5 [&_h2]:text-[20px] [&_h2]:leading-7 [&_h2]:font-semibold [&_h2]:tracking-[0.2px] lg:[&_h2]:my-3.5 lg:[&_h2]:text-[24px] lg:[&_h2]:leading-8 lg:[&_h2]:tracking-[0.15px] [&_h3]:my-2 [&_h3]:text-[18px] [&_h3]:leading-6 [&_h3]:font-semibold [&_h3]:tracking-[0.2px] lg:[&_h3]:my-3 lg:[&_h3]:leading-8 [&_ol]:my-3 [&_ol]:list-decimal [&_ol]:pl-6 [&_p:not(:last-child)]:mb-2 [&_strong]:font-semibold [&_ul]:my-3 [&_ul]:list-disc [&_ul]:pl-6 [&_video]:h-auto [&_video]:max-w-full" dangerouslySetInnerHTML={{
      __html: description
    }} />;
    $[5] = description;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t("profile-page.about.read-more");
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("profile-page.about.read-less");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = cn("text-vive-primary-30 landscape:text-vive-primary-30 w-full text-[12px] leading-[18px] tracking-[0.2px] lg:text-[16px] lg:leading-6 lg:tracking-[0.25px] lg:text-white landscape:text-[12px] landscape:leading-[18px] landscape:tracking-[0.2px]", "whitespace-normal");
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t8 = <ReadMoreText contentElement="div" content={t4} collapsible={true} onCollapse={handleCollapse} readMoreLabel={t5} readLessLabel={t6} readMoreButtonClassName="text-vive-brand-40 text-[12px] lg:text-[14px] landscape:text-[12px] font-semibold" className={t7} />;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t3 || $[17] !== t8) {
    t9 = <section ref={sectionRef} className="bg-vive-staff-description-mobile flex scroll-mt-2 flex-col gap-2 rounded-[15px] p-4 lg:bg-white/10">{t3}{t8}</section>;
    $[16] = t3;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}
export default StaffDescription;